import AllEstateOverview from "@/components/portfolio/AllEstateOverview";
import SingleEstateOverview from "@/components/portfolio/SingleEstateOverview";
import { useEstateContext } from "@/context/EstateContext";
import React from "react";

const SelectedEstateCard = ({ embedded = false }: { embedded?: boolean }) => {
  const { selectedEstate } = useEstateContext();

  return (
    <>
      {selectedEstate ? (
        <>
          <SingleEstateOverview
            selectedEstate={selectedEstate}
            embedded={embedded}
          />
        </>
      ) : (
        <>
          <AllEstateOverview embedded={embedded} />
        </>
      )}
    </>
  );
};

export default SelectedEstateCard;
